/**
 * Adresse de lancement envoyée par l'appli TPE (intent VIEW vers la caisse) :
 * https://pos.visionpos.fr/mode-stock?vue=maj&code=<code>. On n'en garde que le Mode Stock,
 * la vue et le code ; tout le reste est ignoré.
 */
const VIEWS = new Set(['maj', 'reception', 'inventaire', 'stocks', 'etiquettes']);
const CODE = /^[\x21-\x7e]{1,64}$/;

export const parseLaunchUrl = (raw: string | null | undefined): string | null => {
  if (!raw) return null;
  let url: URL;
  try {
    url = new URL(raw, 'https://pos.visionpos.fr');
  } catch {
    return null;
  }
  if (url.pathname.replace(/\/$/, '') !== '/mode-stock') return null;
  const params = new URLSearchParams();
  const view = url.searchParams.get('vue');
  params.set('vue', view && VIEWS.has(view) ? view : 'maj');
  const code = url.searchParams.get('code')?.trim();
  if (code && CODE.test(code)) params.set('code', code);
  return `/mode-stock?${params.toString()}`;
};
